<template>
  <div class="overall-bg">
    <b-container>
      <b-row>
        <b-col lg="6" md="4" sm="12" cols="12">
          <BacktoPage :goback="$router.back"></BacktoPage>
          <Headerlayout headertext="Compare Quotes"
            contenttext="Tax type list is a comprehensive list of the various types of taxes that are imposed on individuals, businesses, and organizations.It includes federal income tax, state income tax, Social Security tax, Medicare tax, payroll tax, and other taxes related to the sale of goods and services.">
          </Headerlayout>
        </b-col>
        <b-col class="d-flex flex-row-reverse">
          <div class="field">
            <label>Items</label>
            <AutoCompleteCustom :suggestions="items" @complete="" />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <MasterEmpty :createline="false" v-if="(items.length && lableitem.length) === 0 && !loading"
        eheader="Quotes Comparision" econtent="Purchase Indent" eimg="/src/assets/Img/icons/sub-tax.svg"
        @createNew="" />
      <div v-if="(items.length && lableitem.length) !== 0">
        <div class="d-inline-flex">
          <!-- <div v-for="item in items">
                    {{ item['ItemId'] }}ok
                </div> -->
          <!-- <div class="d-flex">
                    <div v-for="supplier in output" :key="supplier.SupplierId">
                        <h2>Supplier {{ supplier.SupplierId }}</h2>

                        <div>
                            <div v-for="item in getSupplierItems(supplier)" :key="item.ItemId">
                                <div v-if="item.itembool == true"> {{ item.name }} ({{ item.itembool }}) {{ item.ItemId
                                }}</div>
                                <div v-else>
                                    <p>Dummy {{ item.ItemId }}</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
        </div>
        <div class="d-flex">
          <div class="col-label-width">
            <div class="empty-div1 sticky-div"></div>
            <div class="value-label height1">
              <p class="value">Overall value</p>
              <p>% of free by value</p>
              <p>Effective Tax</p>
              <p>Discount</p>
              <p>Landing cost</p>
              <p>Payment terms</p>
              <p>Delivery Terms</p>
            </div>
            <div v-for="item in lableitem">
              <div class="height2 d-flex align-items-center">
                <p class="m-title">{{ item["ItemName"] }}</p>
              </div>
              <div class="I-label height3">
                <p>Cost per unit</p>
                <p>Effective Tax</p>
                <p>Committed Quantity</p>
                <p>Free</p>
                <p>Expiry min and max</p>
              </div>
            </div>
            <div class="height4 d-flex align-items-center justify-content-end">
              <p class="m-title">Attachment</p>
            </div>
            <div class="height5 d-flex align-items-center justify-content-end">
              <p class="m-title">Advanced Analysis</p>
            </div>
            <div class="height6">
              <p class="m-title">Summary</p>
              <div class="m-label" v-for="item in lableitem">
                <p>{{ item["ItemName"] }}</p>
              </div>
              <p class="m-label">Over all PO Value</p>
            </div>
            <div></div>
          </div>
          <div class="scroll-style">
            <div v-for="supplier in suppliers" :key="supplier['SupplierId']" v-if="!loading">
              <div class="col-content-width">
                <div class="supplier-name sticky-div empty-div1">
                  <p class="code">SUP9856</p>
                  <p class="h-title">{{ supplier["SupplierName"] }}</p>
                  <div class="tags">
                    <div class="c-tags">
                      <p>Cheapest</p>
                    </div>
                    <div class="supplier">
                      <p>New Suplier</p>
                    </div>
                  </div>
                </div>
                <div class="w-card height1">
                  <div class="price">
                    <p class="value">₹ {{ supplier["Overallvalue"] }}</p>
                    <p>{{ supplier["PaymentTermsDesc"] }}</p>
                    <p class="E-tax">
                      {{ supplier["EffectiveTo"] == null ? 0 : "" }}
                    </p>
                    <p>{{ supplier["DiscountPer"] }}%</p>
                    <p>₹{{ supplier["LendingRate"] }}</p>
                    <p>{{ supplier["PaymentTermsDesc"] }}</p>
                    <p>
                      {{
                        supplier["DeliTermsDesc"] == ""
                          ? "--"
                          : supplier["DeliTermsDesc"]
                      }}
                    </p>
                  </div>
                </div>
                <div>
                  <div class="" v-for="item in getSupplierItems(supplier)" :key="item['ItemId']">
                    <div class="I-card" v-if="item.itembool == true">
                      <div class="Item-value height2">
                        <b-row class="qty field">
                          <b-col lg="7" md="6" sm="6" cols="6">
                            <label class="cus-label">Requested Quantity</label>
                          </b-col>

                          <b-col lg="5" md="6" sm="6" cols="6">
                            <TextField type="text" placeholder="" clearable name="" v-model="item.ReqQty" disabled />
                          </b-col>
                        </b-row>
                        <b-row class="qty field">
                          <b-col lg="7" md="6" sm="6" cols="6">
                            <label class="cus-label">Quantity</label>
                          </b-col>

                          <b-col lg="5" md="6" sm="6" cols="6">
                            <TextField type="text" placeholder="Enter Discount" name="" v-model="item.qty"
                              @change="qty(item['ItemId'], supplier, item.qty)" :disabled="item.disabled" />
                          </b-col>
                        </b-row>

                        <b-row class="qty field">
                          <b-col lg="7" md="6" sm="6" cols="6">
                            <label class="cus-label">Free</label>
                          </b-col>
                          <b-col lg="5" md="6" sm="6" cols="6">
                            <TextField type="text" placeholder="Enter Discount" clearable name="" />
                          </b-col>
                        </b-row>
                      </div>
                      <div class="Item-price height3">
                        <p>{{ item["UnitRate"] }}</p>
                        <p>{{ item["EffectiveTo"] }}</p>
                        <p>{{ item["Qty"] }}</p>
                        <p>{{ item["FreeQty"] }}</p>
                        <p>>12M (98%) | >6M(2%)</p>
                      </div>
                    </div>
                    <div class="I-card white-bg empty-card d-flex justify-content-center align-items-center"
                      v-else="item.itembool == true">
                      Item is Not Available
                    </div>
                  </div>
                </div>
                <div class="height4 Attach-card"></div>
                <div class="height5 A-card"></div>
                <div class="height6 S-card">
                  <div class="S-info" v-for="item in getSupplierItems(supplier)" :key="item['ItemId']">
                    <div v-if="item.itembool == true" class="summary pt-3">
                      <p>x{{ item.qty }}</p>
                      <p>{{ item.UnitRate }}</p>
                    </div>
                    <div v-else="item.itembool == true" class="summary pt-3">
                      <p>0</p>
                      <p>0</p>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="Submit-card">
                    <Button class="Submit-btn" @click="confirm(supplier)" :disabled="supplier['btnDisabled']">
                      {{ supplier["content"] }}
                    </Button>
                    <p class="btn-txt">
                      This will need a approval from your HOD/Management
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="item in 5" v-if="loading">
              <div class="col-content-width">
                <div class="supplier-name sticky-div empty-div1 border-bottom-0">
                  <Skeleton height=".5rem" width="25%" class="mb-2"></Skeleton>
                  <Skeleton height=".75rem" width="65%" class="mb-3"></Skeleton>

                  <div class="tags">
                    <Skeleton height=".75rem" width="25%" class="mb-2"></Skeleton>
                    <Skeleton height=".75rem" width="25%" class="mb-2"></Skeleton>
                  </div>
                </div>
                <div class="w-card height1">
                  <div class="d-flex align-items-end flex-column">
                    <Skeleton height=".75rem" width="65%" class="my-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-5"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-4"></Skeleton>
                  </div>
                </div>
                <div class="w-card height1">
                  <div class="d-flex align-items-end flex-column">
                    <Skeleton height=".75rem" width="65%" class="my-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-5"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-4"></Skeleton>
                  </div>
                </div>
                <div class="w-card height1">
                  <div class="d-flex align-items-end flex-column">
                    <Skeleton height=".75rem" width="65%" class="my-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-5"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-4"></Skeleton>
                  </div>
                </div>
                <div class="w-card">
                  <div class="d-flex align-items-end flex-column">
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    <Skeleton height=".75rem" width="85%" class="mb-3"></Skeleton>
                  </div>
                </div>

                <div class="height6 S-card">
                  <div class="S-info">
                    <div class="summary py-3">
                      <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                      <Skeleton height=".75rem" width="35%" class="mb-3"></Skeleton>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="Submit-card d-flex align-items-center flex-column">
                    <Skeleton height="2.5rem" width="90%" class="mb-3"></Skeleton>
                    <Skeleton height="2.5rem" width="90%" class="mb-3"></Skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
  <QuotesConfirmation v-model:triggers="show" v-model="quotecompare" @load="show = false" @ok="show = false"
    @close="show = false" @sendpo="sendpo()" />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import QuotesConfirmation from "./QuotesConfirmation.vue";
import commonService from "../../../Service/WithoutStockAffectService";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import common from "../../../../../modules/Inventory/Service/CommonService";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
// import Itemservice from "../../../../modules/Inventory/Service/ItemMasService";
import moment from "moment";

export default defineComponent({
  components: {
    CreateSuccessully,
    TextField,
    Headerlayout,
    BacktoPage,
    QuotesConfirmation,
    AutoCompleteCustom,
    MasterEmpty,
    Loader,
  },
  setup() {
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    onMounted(() => {
      GetCode();
      QuotesDetails();
    });

    const route = useRoute();
    let QuoteId = route.query.Id;
    let StoreId = ref(0);

    let showDialog = ref(false);
    let items = ref([]);
    let Supplierlist = ref();
    let output = ref();
    let loading = ref(false);

    const suppliers = ref([
      // { SupplierId: 101, Item: [{ ItemId: 48, Qty: 8 }, { ItemId: 49, Qty: 3 }] },
      // { SupplierId: 102, Item: [{ ItemId: 49, Qty: 4 }] },
    ]);
    const successpop = ref(false);

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        FormId: 1020,
        HospitalId: HospitalId,
        BranchId: BranchId,
      };
      let result: any = await common.getCodeTemplate(data);

      requestForm.value.DocNo = result;
    }

    let overallval = ref();
    async function QuotesDetails() {
      debugger;
      try {
        loading.value = true;
        let response = await commonService.ListGetByRefId(QuoteId, 3);
        lableitem.value = response["result"].filter((item, index, arr) => {
          return arr.findIndex((i) => i.ItemId === item.ItemId) === index;
        });

        items.value = response["result"];

        StoreId.value = response["result"][0]["StoreId"];

        suppliers.value = response["result"].reduce(
          (
            acc,
            {
              SupplierName,
              Suppliercode,
              Overallvalue,
              FreeQty,
              EffectiveTo,
              DiscountPer,
              LendingRate,
              PaymentTermsDesc,
              DeliTermsDesc,
              SupplierId,
              ItemId,
              Qty,
              UnitRate,
              Rate,
              PackSizeId,
              HSNId,
              RefId,
              Id,
              StockWOTransId,
            }
          ) => {
            const itemIndex = acc.findIndex(
              (item) => item.SupplierId === SupplierId
            );
            debugger;
            Overallvalue = 1;
            if (itemIndex >= 0) {
              const existingItemIndex = acc[itemIndex].Item.findIndex(
                (item) => item.ItemId === ItemId
              );
              if (existingItemIndex < 0) {
                acc[itemIndex].Item.push({
                  ItemId,
                  Qty,
                  UnitRate,
                  Rate,
                  PackSizeId,
                  HSNId,
                  RefId,
                  Id,
                  FreeQty,
                  EffectiveTo,
                });
              }
            } else {
              acc.push({
                StockWOTransId,
                SupplierId,
                SupplierName,
                Suppliercode,
                Overallvalue,
                FreeQty,
                EffectiveTo,
                DiscountPer,
                LendingRate,
                PaymentTermsDesc,
                DeliTermsDesc,
                Rate,
                Item: [
                  {
                    ItemId,
                    Qty,
                    UnitRate,
                    Rate,
                    PackSizeId,
                    HSNId,
                    RefId,
                    Id,
                    FreeQty,
                    EffectiveTo,
                  },
                ],
              });
            }
            return acc;
          },
          [] as {
            StockWOTransId: number;
            SupplierId: number;
            SupplierName: String;
            Suppliercode: String;
            Overallvalue: String;
            FreeQty: String;
            EffectiveTo: String;
            DiscountPer: String;
            LendingRate: 0;
            PaymentTermsDesc: String;
            DeliTermsDesc: String;
            Rate: number;
            Item: {
              ItemId: number;
              Qty: number;
              UnitRate: number;
              Rate: number;
              PackSizeId: number;
              HSNId: number;
              RefId: number;
              Id: number;
              FreeQty: number;
              EffectiveTo: number;
            }[];
          }[]
        );
        debugger;

        suppliers.value.map((item: any) => {
          item.content = "Confirm This Supplier and Send PO";
          let Supplier = response["result"].find(
            (i1) => i1.SupplierId == item.SupplierId
          );
          console.log(Supplier);
          if (Supplier.RefCount == 1) {
            item.btnDisabled = true;
            item.content = "Converted To PO";
            item["QuoteConverted"] = "1";
            item["Item"].map((i1) => {
              let itm = response["result"].find(
                (i2) =>
                  i2.ItemId == i1.ItemId && i2.SupplierId == item.SupplierId
              );
              i1["QuoteQuantity"] = itm.RefQuantity;
              i1["ItemQuantity"] = itm.RefQuantity;
              i1["disabled"] = true;
              return i1;
            });
          } else {
            item.btnDisabled = false;
            item.content = "Confirm This Supplier and Send PO";
          }
          return item;
        });
        loading.value = false;
        dataloop();
      } catch (error) {
        console.log(error);
      }
    }

    let lableitem = ref([]);

    let Quotevalue = ref();
    function confirm(value) {
      debugger;
      Quotevalue.value = value;
      quotecompare.value.SupplierName = value.SupplierName;
      quotecompare.value.PaymentTermsDesc = value.PaymentTermsDesc;
      quotecompare.value.DeliTermsDesc = value.DeliTermsDesc;

      quotecompare.value.Discount = value.DiscountPer;
      quotecompare.value.LendingRate = value.LendingRate;
      quotecompare.value.Overallvalue = value.Overallvalue;
      quotecompare.value.FreeQty = value.FreeQty;
      quotecompare.value.EffectiveTo = value.EffectiveTo;
      showDialog.value = true;
    }
    let qtytxt = ref();
    function qty(itemId, supplier, event1) {
      debugger;
      let event = event1;
      let supplierId = supplier.SupplierId;
      let qtycount = 0;
      let quoteconverted: any = suppliers.value.find(
        (i1: any) => i1.SupplierId == supplierId
      );

      Object.values(suppliers.value).forEach((items: any) => {
        let totquantity = 0;

        if (items["SupplierId"] == supplierId) {
          if (items["Item"].length > 0) {
            items["Item"]
              .filter((i1) => i1.ItemId == itemId)
              .map((i2) => {
                Object.values(suppliers.value).forEach((it1: any) => {
                  if ((it1?.["QuoteConverted"] ?? 0) == "1") {
                    let q1 = it1["Item"].filter(
                      (it2) => it2.ItemId == i2.ItemId
                    );
                    if (q1.length > 0)
                      totquantity = totquantity + q1[0]?.ItemQuantity ?? 0;
                  }
                });
                if ((items?.["QuoteConverted"] ?? 0) != "1") {
                  i2.ItemQuantity =
                    Number(event) + totquantity <= i2.Qty
                      ? Number(event) ?? 0
                      : 0;
                } else {
                  let val = i2.QuoteQuantity;
                  i2.ItemQuantity = val;
                }
                qtycount = qtycount + i2.ItemQuantity;
                return i2;
              });
          }
        } else {
          if (items["Item"].length > 0) {
            items["Item"]
              .filter((i1) => i1.ItemId == itemId)
              .map((i2) => {
                Object.values(suppliers.value).forEach((it1: any) => {
                  if (it1["QuoteConverted"] == "1") {
                    let q1 = it1["Item"].filter(
                      (it2) => it2.ItemId == i2.ItemId
                    );
                    if (q1.length > 0)
                      totquantity = totquantity + q1[0]?.ItemQuantity ?? 0;
                  }
                });
                if (
                  items["QuoteConverted"] != "1" &&
                  quoteconverted?.QuoteConverted != "1"
                ) {
                  i2.ItemQuantity =
                    Number(event) + totquantity <= i2.Qty
                      ? i2.Qty - (Number(event) + totquantity)
                      : 0;
                }

                return i2;
              });
          }
        }
      });
    }

    const getSupplierItems = (supplier) => {
      debugger;
      const supplierItems = supplier.Item.map((x) => x.ItemId);
      const supplierItemsWithQty = items.value
        .filter((item) => supplierItems.includes(item["ItemId"]))
        .map((item) => ({
          ...(item as object),
          itembool: supplierItems.includes(item["ItemId"]),
          ReqQty:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.Qty || 0,
          qty:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])
              ?.ItemQuantity || 0,
          UnitRate:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.UnitRate ||
            0,
          Rate:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.Rate || 0,
          PackSizeId:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])
              ?.PackSizeId || 0,
          HSNId:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.HSNId || 0,
          RefId:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.RefId || 0,
          Id: supplier.Item.find((x) => x.ItemId === item["ItemId"])?.Id || 0,
          FreeQty:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.FreeQty ||
            0,
          EffectiveTo:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])
              ?.EffectiveTo || 0,
          disabled:
            supplier.Item.find((x) => x.ItemId === item["ItemId"])?.disabled ||
            false,
        }));

      const nonSupplierItems = items.value.filter(
        (item) => !supplierItems.includes(item["ItemId"])
      );

      const nonSupplierItemsWithQty = nonSupplierItems.map((item) => ({
        ...(item as object),
        itembool: false,
        ReqQty: 0,
        qty: 0,
        UnitRate: 0,
        Rate: 0,
        PackSizeId: 0,
        HSNId: 0,
        RefId: 0,
        Id: 0,
        FreeQty: 0,
        EffectiveTo: 0,
        disabled: false,
      }));

      const allItems = supplierItemsWithQty.concat(nonSupplierItemsWithQty);
      const uniqueItems = allItems.filter((item, index, self) => {
        return index === self.findIndex((t) => t["ItemId"] === item["ItemId"]);
      });

      const sortedItems = uniqueItems.sort((a, b) => {
        if (a["ItemId"] < b["ItemId"]) return -1;
        if (a["ItemId"] > b["ItemId"]) return 1;
        return 0;
      });
      return sortedItems;
    };

    const sortedSuppliers = computed(() =>
      suppliers.value.sort((a, b) => {
        if (a["SupplierId"] < b["SupplierId"]) return -1;
        if (a["SupplierId"] > b["SupplierId"]) return 1;
        return 0;
      })
    );

    //Api
    var arr: any = [];
    let currentDate = new Date().toISOString().slice(0, 10);
    let currentDate1 = new Date().toISOString();

    const requestForm = ref({
      Id: 0,
      DocType: "4",
      DocNo: "",
      RefId: 0,
      RefNo: "",
      SupplierId: 0,
      DocDate: currentDate1,
      FromStore: 0,
      ToStore: 0,
      HospitalId: 0,
      BranchId: 0,
      Remarks: "",
      CreatedAt: currentDate,
      StoreId: StoreId.value,
      ModifiedAt: "",
      ModifiedBy: 0,
      CreatedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      // Amount: 0.0,
    });

    let quotecompare = ref({
      Remarks: "",
      SupplierName: "",
      SupplierId: 0,
      SupplierCode: "",
      Overallvalue: "",
      FreeQty: "",
      EffectiveTo: "",
      Discount: "",
      LendingRate: 0,
      PaymentTermsDesc: "",
      DeliTermsDesc: "",
    });

    const sendpo = async () => {
      let response: any;
      let message = "";
      let id: any;
      debugger;
      console.log(Quotevalue.value);
      console.log(requestForm);
      requestForm.value.SupplierId = Quotevalue.value.SupplierId;
      requestForm.value.RefId = Quotevalue.value.StockWOTransId;
      requestForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      requestForm.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      requestForm.value.BranchId = BranchId;
      requestForm.value.HospitalId = HospitalId;
      requestForm.value.ModifiedBy = UserId;
      requestForm.value.CreatedBy = UserId;
      requestForm.value.EntityId = 3044;
      requestForm.value.EntityOperationId = 3044001;
      requestForm.value.StoreId = StoreId.value;
      requestForm.value.Remarks = quotecompare.value.Remarks;
      console.log(requestForm.value);

      response = await commonService.createStockWOTM(requestForm.value);
      id = response["result"];
      message = response["ErrorInfo"].ErrorCode;
      if (message == null) {
        debugger;
        let g = 0;
        for (let i = 0; i < Quotevalue.value.Item.length; i++) {
          if (Quotevalue.value.Item[i]["ItemQuantity"]) {
            let obj = {};
            let ref = Quotevalue.value.Item[i]["RefId"];
            (obj["ItemId"] = Quotevalue.value.Item[i]["ItemId"]),
              (obj["Qty"] = Quotevalue.value.Item[i]["ItemQuantity"]),
              (obj["RefId"] = id),
              (obj["PackSizeId"] = Quotevalue.value.Item[i]["PackSizeId"]),
              (obj["HSNId"] = Quotevalue.value.Item[i]["HSNId"]),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),
              (obj["Rate"] = Quotevalue.value.Item[i]["Rate"]),
              (obj["UnitRate"] = Quotevalue.value.Item[i]["UnitRate"]);
            // obj["Id"] = ref;
            arr[g] = obj;
            g++;
          }
        }
        console.log(arr);
        let result = await commonService.createStockWODetails(arr);
        message = result["ErrorInfo"].ErrorCode;
        if (message == null) {
          showDialog.value = false;
          suppliers.value
            .filter(
              (items1) => items1["SupplierId"] == requestForm.value.SupplierId
            )
            .map((item: any) => {
              item["QuoteConverted"] = "1";
              item["content"] = "Converted To PO";
              item["btnDisabled"] = true;
              item["Item"].map((i1) => {
                let arr = Quotevalue.value.Item.find(
                  (i2) => i2.ItemId == i1.ItemId
                );
                i1["QuoteQuantity"] = arr.ItemQuantity;
                i1["disabled"] = true;
                return i1;
              });
              return item;
            });

          console.log(suppliers.value);
          Object.values(suppliers.value).forEach((items: any) => {
            if (
              items["SupplierId"] != requestForm.value.SupplierId &&
              items["QuoteConverted"] != "1"
            ) {
              if (items["Item"].length > 0) {
                items["Item"].map((i1) => {
                  let rowItem = Quotevalue.value.Item.filter(
                    (z1) => z1.ItemId == i1.ItemId
                  );
                  let totquantity = 0;
                  Object.values(suppliers.value).forEach((it1: any) => {
                    if (it1["QuoteConverted"] == "1") {
                      let q1 = it1["Item"].filter(
                        (it2) => it2.ItemId == i1.ItemId
                      );
                      if (q1.length > 0)
                        totquantity = totquantity + q1?.[0]?.ItemQuantity ?? 0;
                    }
                  });
                  if (i1.ItemId == rowItem?.[0]?.ItemId) {
                    i1.ItemQuantity = Math.abs(
                      Number(i1.Qty) - Number(totquantity)
                    );
                  }
                  return i1;
                });
              }
            }
          });
          console.log(suppliers.value);
          successpop.value = true;
        } else {
        }
      }
    };

    function closetrigger() {
      successpop.value = false;
    }

    function dataloop() {
      debugger;
      for (let i = 0; i < suppliers.value.length; i++) {
        let supplier: any = suppliers.value[i];

        let items = getSupplierItems(supplier);
        supplier["Overallvalue"] = Number(
          items.reduce((sum, obj) => sum + obj.Rate, 0)
        );

        for (let j = 0; j < items.length; j++) {
          debugger;

          overallval.value = items.reduce((sum, obj) => sum + obj.Rate, 0);
        }
      }
    }
    return {
      overallval,
      successpop,
      closetrigger,
      quotecompare,
      requestForm,
      items,
      suppliers: sortedSuppliers,
      getSupplierItems,
      qty,
      sendpo,
      qtytxt,
      confirm,
      show: showDialog,
      Supplierlist,
      lableitem,
      output,
      loading,
    };
  },
});
</script>

<style lang="scss" scoped>
.cus-label {
  color: white;
  padding-top: 25px;
  text-align: right;
}

.Submit-card {
  background-color: white;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  text-align: center;

  .Submit-btn {
    margin: 20px;
    background-color: #3096ff;
    border: #3096ff;
    text-align: center;
    border-radius: 7px;

    p {
      color: #ffffff;
    }
  }

  .btn-txt {
    color: #999999;
    text-align: center;
    padding: 15px;
  }
}

.A-card {
  background-color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.Attach-card {
  background-color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.S-card {
  background-color: white;
  padding: 10px;

  .S-info {
    text-align: right;
    font-weight: 700;
    color: #444444;

    .summary {
      margin-left: 30px;
      margin-right: 30px;

      display: flex;
      justify-content: space-between;

      p {
        margin-bottom: 0px;
        padding: 10px;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
}

.m-title {
  font-weight: 700;
  font-size: 15px;
  text-align: right;
}

.m-label {
  text-align: right;
  font-weight: 400;
  color: #999999;

  p {
    padding: 10px;
    font-weight: 500;
    font-size: 14px;
  }
}

.I-label {
  text-align: right;
  font-weight: 500;
  color: #999999;

  .value {
    margin: 10px;
    font-weight: 800;
    font-size: 15px;
  }

  p {
    padding: 10px;
    padding-bottom: 0px;
    font-weight: 500;
    font-size: 14px;
  }
}

.value-label {
  text-align: right;
  padding-top: 15px;

  .value {
    margin: 10px;
    font-weight: 800;
    font-size: 15px;
    color: #000000;
  }

  p {
    margin: 10px;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
  }
}

.I-card {
  background-color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;

  .Item-price {
    text-align: right;
    font-weight: 700;
    color: #444444;

    .value {
      margin: 10px;
      font-weight: 800;
      font-size: 15px;
    }

    p {
      padding: 10px;
      padding-bottom: 0px;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .Item-value {
    background-color: #0148e2;
    padding: 10px;

    .qty {
      margin-bottom: 0px;
    }

    p {
      color: white;
      align-self: center;
      padding: 10px;
    }
  }
}

.supplier-name {
  padding: 15px;
  background-color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  border-bottom: 1px solid #e1e1e1;

  .h-title {
    font-weight: 700;
    font-size: 15px;
  }

  .code {
    font-size: 11px;
    font-weight: 300;
    color: #999999;
  }

  .tags {
    padding-top: 10px;
    display: flex;

    .c-tags {
      background-color: #e7f8f0;
      color: #479e64;
      font-size: 15px;
      padding: 2px;
    }

    .supplier {
      padding-left: 10px;
      padding-top: 5px;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
    }
  }
}

.w-card {
  padding: 15px;
  background-color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;

  .price {
    text-align: right;
    font-weight: 700;
    color: #444444;

    .value {
      margin: 10px;
      font-weight: 800;
      font-size: 15px;
    }

    .highlight {
      color: #3096ff;
    }

    p {
      margin: 10px;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
  }
}

.scroll-style {
  width: 100%;
  overflow-x: auto;
  display: flex;
}

.col-label-width {
  width: 200px;
  margin: 20px;
}

.col-content-width {
  width: 275px;
  margin: 15px;
}

.height1 {
  height: 250px;
}

.empty-div1 {
  height: 105px;
}

.height2 {
  height: 200px;
}

.height3 {
  height: 165px;
}

.height4 {
  height: 100px;
}

.height5 {
  height: 150px;
}

.height6 {
  height: auto;
}

.white-bg {
  background-color: #e1e1e1;
}

.empty-card {
  height: 300px;
}
</style>
